import { Button, ButtonGroup, Stack } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { getFlagReviewButtonSx } from "./review-decision-button-presenters"

export function ChangeItemFooter({ change, onDecisionChange }) {
    const isFlaggedForReview = change.decision === "custom"

    return (
        <Stack direction="row" spacing={1} justifyContent="flex-end">
            <ButtonGroup size="small" variant="outlined">
                <Button
                    color={change.decision === "accept" ? "success" : "inherit"}
                    variant={change.decision === "accept" ? "contained" : "outlined"}
                    onClick={acceptChange}
                    startIcon={<Iconify icon="mdi:check" />}
                    sx={change.decision === "accept" ? { color: "common.white" } : undefined}
                >
                    Accept
                </Button>
                <Button
                    color={change.decision === "keep" ? "primary" : "inherit"}
                    variant={change.decision === "keep" ? "contained" : "outlined"}
                    onClick={keepChange}
                    startIcon={<Iconify icon="mdi:close" />}
                >
                    Keep Current
                </Button>
                <Button
                    color="inherit"
                    variant={isFlaggedForReview ? "contained" : "outlined"}
                    onClick={flagChange}
                    startIcon={<Iconify icon="mdi:flag-outline" />}
                    sx={resolveFlagButtonSx()}
                >
                    Flag for Review
                </Button>
            </ButtonGroup>
        </Stack>
    )

    function acceptChange() {
        onDecisionChange?.(change.id, "accept")
    }

    function keepChange() {
        onDecisionChange?.(change.id, "keep")
    }

    function flagChange() {
        onDecisionChange?.(change.id, change.decision === "custom" ? null : "custom")
    }

    function resolveFlagButtonSx() {
        if (isFlaggedForReview) {
            return getFlagReviewButtonSx({ selected: true })
        }

        return {
            color: "text.primary",
            borderColor: "divider",
            "&:hover": {
                color: "text.primary",
                borderColor: "text.primary",
                bgcolor: "action.hover",
            },
        }
    }
}
